export const filter = {
  house: 'House',
  section: 'Section',
  floor: 'Floor',
};
